import React, { useState, useRef, useEffect } from 'react';
import { motion } from 'framer-motion';
import NavBar from '../components/Navbar/NavBar';
import Footer from '../components/Footer';
import {useDocTitle} from '../components/CustomHook';
import { Link, useSearchParams } from 'react-router-dom';
import axios from 'axios';
// import emailjs from 'emailjs-com';
import Notiflix from 'notiflix';
import SEO from '../components/SEO';

const DemoProduct = () => {
    const [searchParams] = useSearchParams();
    useDocTitle('Tomorrow Global - Demander une Démo')

    const [firstName, setFirstName] = useState('')
    const [lastName, setLastName] = useState('')
    const [email, setEmail] = useState('')
    const [phone, setPhone] = useState('')
    const [message, setMessage] = useState('')
    const [demoServices, setDemoServices] = useState([])
    const [errors, setErrors] = useState([])
    const [isDropdownOpen, setIsDropdownOpen] = useState(false)
    const [searchTerm, setSearchTerm] = useState('')
    const dropdownRef = useRef(null)

    // Services data matching the Services component
    const allServices = [
        {
            id: 'achat-media',
            name: 'Achat Media',
            icon: '📺'
        },
        {
            id: 'production-audiovisuelle',
            name: 'Production Audiovisuelle',
            icon: '🎬'
        },
        {
            id: 'digital-media',
            name: 'Digital Media',
            icon: '💻'
        },
        {
            id: 'consulting-strategie',
            name: 'Consulting & Stratégie',
            icon: '📊'
        },
        {
            id: 'design-creativite',
            name: 'Design & Créativité',
            icon: '🎨'
        },
        {
            id: 'evenementielle',
            name: 'Événementielle',
            icon: '🎪'
        },
        {
            id: 'animation-2d-3d',
            name: 'Animation 2D & 3D',
            icon: '✨'
        },
        {
            id: 'influence-marketing',
            name: 'Influence Marketing',
            icon: '📱'
        }
    ];

    // Check for service in URL parameter and pre-select it
    useEffect(() => {
        const serviceId = searchParams.get('service');
        if (serviceId && !demoServices.includes(serviceId)) {
            setDemoServices([serviceId]);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchParams]);

    // Filter services based on search term
    const filteredServices = allServices.filter(service =>
        service.name.toLowerCase().includes(searchTerm.toLowerCase())
    )

    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsDropdownOpen(false)
            }
        }
        document.addEventListener('mousedown', handleClickOutside)
        return () => document.removeEventListener('mousedown', handleClickOutside)
    }, [])

    const toggleService = (serviceId) => {
        if (demoServices.includes(serviceId)) {
            setDemoServices(demoServices.filter(id => id !== serviceId))
        } else {
            setDemoServices([...demoServices, serviceId])
        }
    }

    const removeService = (serviceId) => {
        setDemoServices(demoServices.filter(id => id !== serviceId))
    }


    const clearErrors = () => {
        setErrors([])
    }

    const clearInput = () => {
        setFirstName('')
        setLastName('')
        setEmail('')
        setPhone('')
        setMessage('')
    }
    
    function sendEmail(e) {
        e.preventDefault();
        document.getElementById('submitBtn').disabled = true;
        document.getElementById('submitBtn').innerHTML = 'Chargement...';
        let fData = new FormData();
        fData.append('first_name', firstName)
        fData.append('last_name', lastName)
        fData.append('email', email)
        fData.append('phone_number', phone)
        fData.append('message', message)
        fData.append('services', demoServices)

        // emailjs.sendForm('service_7uy4ojg', 'template_et9wvdg', e.target, 'user_uE0bSPGbhRTmAF3I2fd3s')
        //   .then((result) => {
        //       console.log(result.text);
        //       Notiflix.Report.success(
        //         'Success',
        //         '"Thanks for sending a message, we\'ll be in touch soon."',
        //         'Okay',
        //         );
        //   }, (error) => {
        //       console.log(error.text);
        //       Notiflix.Report.failure(
        //         'An error occured',
        //         'Please try sending the message again.',
        //         'Okay',
        //         );
        //   });

        axios({
            method: "post",
            url: process.env.REACT_APP_DEMO_REQUEST_API,
            data: fData,
            headers: {
                'Content-Type':  'multipart/form-data'
            }
        })
        .then(function (response) {
            document.getElementById('submitBtn').disabled = false;
            document.getElementById('submitBtn').innerHTML = 'envoyer le message';
            clearInput()
            //handle success
            Notiflix.Report.success(
                'Succès',
                response.data.message,
                'D\'accord',
            );
        })
        .catch(function (error) {
            document.getElementById('submitBtn').disabled = false;
            document.getElementById('submitBtn').innerHTML = 'envoyer le message';
            //handle error
            const { response } = error;
            if(response.status === 500) {
                Notiflix.Report.failure(
                    'Une erreur s\'est produite',
                    response.data.message,
                    'D\'accord',
                );
            }
            if(response.data.errors !== null) {
                setErrors(response.data.errors)
            }
            
        });
    }
    return (
        <>
            <SEO 
                title="Demander une Démo - Tomorrow Global | Services Média & Communication"
                description="Demandez une démonstration de nos services : Achat Media, Production Audiovisuelle, Digital Media, Consulting, Design, Événementielle, Animation 2D/3D, Influence Marketing. Remplissez le formulaire pour planifier votre démo personnalisée."
                keywords="demander démo, démonstration services média, planifier démo Tomorrow Global, essai gratuit, consultation gratuite, démo achat média, démo production audiovisuelle"
            />
            <div>
                <NavBar />
            </div>
            <div 
                id='demo' 
                className="flex justify-center items-center mt-8 w-full bg-white dark:bg-black py-12 lg:py-24 pt-24"
            >
                <div className="container mx-auto my-8 px-4 lg:px-20">
                    {/* Back Button */}
                    <motion.div 
                        className="mb-8"
                        initial={{ opacity: 0, x: -50 }}
                        animate={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.6 }}
                    >
                        <Link 
                            to="/" 
                            className="inline-flex items-center text-gray-900 dark:text-white hover:text-gray-700 dark:hover:text-gray-300 font-semibold transition duration-300"
                        >
                            <motion.svg 
                                className="w-5 h-5 mr-2" 
                                fill="none" 
                                stroke="currentColor" 
                                viewBox="0 0 24 24"
                                whileHover={{ x: -5 }}
                                transition={{ duration: 0.2 }}
                            >
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
                            </motion.svg>
                            Retour à l'accueil
                        </Link>
                    </motion.div>
                    <form onSubmit={sendEmail} id="demoProductForm">
                        <motion.div 
                            className="w-full bg-white dark:bg-[#111111] p-8 my-4 md:px-12 lg:w-9/12 lg:pl-20 lg:pr-40 mr-auto rounded-2xl shadow-2xl border border-gray-200 dark:border-[#262626]"
                            initial={{ opacity: 0, y: 50, scale: 0.9 }}
                            whileInView={{ opacity: 1, y: 0, scale: 1 }}
                            viewport={{ once: true, margin: "-100px" }}
                            transition={{ duration: 0.8 }}
                        >
                            <motion.div className="flex">
                                <motion.h1 
                                    className="font-bold text-center lg:text-left uppercase text-4xl text-gray-900 dark:text-white"
                                    initial={{ opacity: 0, y: -20 }}
                                    whileInView={{ opacity: 1, y: 0 }}
                                    viewport={{ once: true }}
                                    transition={{ duration: 0.6 }}
                                >
                                    Demander une Démo
                                </motion.h1>
                            </motion.div>
                            
                            {/* Service Selection Dropdown */}
                            <div className="my-8">
                                <label className="block text-lg font-semibold text-gray-900 dark:text-white mb-4">
                                    Sélectionnez les services qui vous intéressent :
                                </label>
                                
                                {/* Selected Services Display */}
                                {demoServices.length > 0 && (
                                    <div className="mb-4">
                                        <div className="flex flex-wrap gap-2">
                                            {demoServices.map(serviceId => {
                                                const service = allServices.find(s => s.id === serviceId)
                                                return (
                                                    <div key={serviceId} className="bg-gray-200 dark:bg-[#171717] text-gray-800 dark:text-white px-3 py-2 rounded-full text-sm flex items-center gap-2">
                                                        <span>{service?.icon}</span>
                                                        <span>{service?.name}</span>
                                                        <button
                                                            type="button"
                                                            onClick={() => removeService(serviceId)}
                                                            className="text-gray-700 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white ml-1"
                                                        >
                                                            ×
                                                        </button>
                                                    </div>
                                                )
                                            })}
                                        </div>
                                    </div>
                                )}

                                {/* Dropdown */}
                                <div className="relative" ref={dropdownRef}>
                                    <div 
                                        className="w-full p-4 border-2 border-gray-300 dark:border-[#262626] rounded-xl cursor-pointer hover:border-gray-400 dark:hover:border-[#333333] transition-colors duration-200 bg-white dark:bg-[#171717]"
                                        onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                                    >
                                        <div className="flex items-center justify-between">
                                            <span className="text-gray-600 dark:text-gray-300">
                                                {demoServices.length === 0 
                                                    ? 'Rechercher et sélectionner des services...' 
                                                    : `${demoServices.length} service(s) sélectionné(s)`
                                                }
                                            </span>
                                            <svg 
                                                className={`w-5 h-5 text-gray-400 dark:text-gray-400 transition-transform duration-200 ${
                                                    isDropdownOpen ? 'rotate-180' : ''
                                                }`} 
                                                fill="none" 
                                                stroke="currentColor" 
                                                viewBox="0 0 24 24"
                                            >
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                                            </svg>
                                        </div>
                                    </div>

                                    {/* Search Input */}
                                    {isDropdownOpen && (
                                        <div className="absolute top-full left-0 right-0 mt-1 bg-white dark:bg-[#111111] border-2 border-gray-300 dark:border-[#262626] rounded-xl shadow-lg z-50">
                                            <div className="p-3 border-b border-gray-200 dark:border-[#262626]">
                                                <input
                                                    type="text"
                                                    placeholder="Rechercher un produit..."
                                                    value={searchTerm}
                                                    onChange={(e) => setSearchTerm(e.target.value)}
                                                    className="w-full p-2 border border-gray-300 dark:border-[#262626] dark:bg-[#171717] dark:text-white rounded-lg focus:outline-none focus:ring-2 focus:ring-gray-500 dark:focus:ring-white"
                                                />
                                            </div>
                                            
                                            {/* Services List */}
                                            <div className="max-h-60 overflow-y-auto">
                                                {filteredServices.length === 0 ? (
                                                    <div className="p-4 text-gray-500 dark:text-gray-400 text-center">
                                                        Aucun service trouvé
                                                    </div>
                                                ) : (
                                                    filteredServices.map(service => (
                                                        <div
                                                            key={service.id}
                                                            className={`p-3 hover:bg-gray-50 dark:hover:bg-[#171717] cursor-pointer flex items-center justify-between ${
                                                                demoServices.includes(service.id) ? 'bg-gray-100 dark:bg-[#171717]' : ''
                                                            }`}
                                                            onClick={() => toggleService(service.id)}
                                                        >
                                                            <div className="flex items-center gap-3">
                                                                <span className="text-xl">{service.icon}</span>
                                                                <span className="text-gray-700 dark:text-white">{service.name}</span>
                                                            </div>
                                                            {demoServices.includes(service.id) && (
                                                                <svg className="w-5 h-5 text-gray-700 dark:text-white" fill="currentColor" viewBox="0 0 20 20">
                                                                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd"></path>
                                                                </svg>
                                                            )}
                                                        </div>
                                                    ))
                                                )}
                                            </div>
                                        </div>
                                    )}
                                </div>
                                
                                {errors && errors.services && (
                                    <p className="text-red-500 text-sm mt-2">{errors.services}</p>
                                )}
                            </div>

                        <div className="grid grid-cols-1 gap-5 md:grid-cols-2 mt-5">
                                <div>
                                    <input 
                                        name="first_name" 
                                        className="w-full bg-gray-100 dark:bg-[#171717] text-gray-900 dark:text-white border border-gray-200 dark:border-[#262626] mt-2 p-3 rounded-lg focus:outline-none focus:shadow-outline focus:ring-2 focus:ring-gray-900 dark:focus:ring-white"
                                        type="text" 
                                        placeholder="Prénom*" 
                                        value={firstName}
                                        onChange={(e)=> setFirstName(e.target.value)}
                                        onKeyUp={clearErrors}
                                    />
                                    {errors && 
                                        <p className="text-red-500 text-sm">{errors.first_name}</p>
                                    }
                                </div>
                                
                                <div>
                                    <input 
                                        name="last_name" 
                                        className="w-full bg-gray-100 dark:bg-[#171717] text-gray-900 dark:text-white border border-gray-200 dark:border-[#262626] mt-2 p-3 rounded-lg focus:outline-none focus:shadow-outline focus:ring-2 focus:ring-gray-900 dark:focus:ring-white"
                                        type="text" 
                                        placeholder="Nom de famille*"
                                        value={lastName}
                                        onChange={(e)=> setLastName(e.target.value)}
                                        onKeyUp={clearErrors}
                                    />
                                    {errors && 
                                        <p className="text-red-500 text-sm">{errors.last_name}</p>
                                    }
                                </div>

                                <div>
                                    <input 
                                        name="email"
                                        className="w-full bg-gray-100 dark:bg-[#171717] text-gray-900 dark:text-white border border-gray-200 dark:border-[#262626] mt-2 p-3 rounded-lg focus:outline-none focus:shadow-outline focus:ring-2 focus:ring-gray-900 dark:focus:ring-white"
                                        type="email" 
                                        placeholder="Email*"
                                        value={email}
                                        onChange={(e)=> setEmail(e.target.value)}
                                        onKeyUp={clearErrors}   
                                    />
                                    {errors && 
                                        <p className="text-red-500 text-sm">{errors.email}</p>
                                    }
                                </div>

                                <div>
                                    <input
                                        name="phone_number" 
                                        className="w-full bg-gray-100 dark:bg-[#171717] text-gray-900 dark:text-white border border-gray-200 dark:border-[#262626] mt-2 p-3 rounded-lg focus:outline-none focus:shadow-outline focus:ring-2 focus:ring-gray-900 dark:focus:ring-white"
                                        type="number" 
                                        placeholder="Téléphone*"
                                        value={phone}
                                        onChange={(e)=> setPhone(e.target.value)}
                                        onKeyUp={clearErrors}
                                    />
                                    {errors && 
                                        <p className="text-red-500 text-sm">{errors.phone_number}</p>
                                    }
                                </div>
                        </div>
                        <div className="my-4">
                            <textarea 
                                name="message" 
                                placeholder="Message*" 
                                className="w-full h-32 bg-gray-100 dark:bg-[#171717] text-gray-900 dark:text-white border border-gray-200 dark:border-[#262626] mt-2 p-3 rounded-lg focus:outline-none focus:shadow-outline focus:ring-2 focus:ring-gray-900 dark:focus:ring-white"
                                value={message}
                                onChange={(e)=> setMessage(e.target.value)}
                                onKeyUp={clearErrors}
                            ></textarea>
                            {errors && 
                                <p className="text-red-500 text-sm">{errors.message}</p>
                            }
                        </div>
                        <div className="my-2 w-1/2 lg:w-2/4">
                            <button type="submit" id="submitBtn" className="uppercase text-sm font-bold tracking-wide bg-gray-900 dark:bg-white dark:text-gray-900 hover:bg-gray-800 dark:hover:bg-gray-100 text-white p-3 rounded-lg w-full 
                                    focus:outline-none focus:shadow-outline transition-colors">
                                Envoyer le Message
                            </button>
                        </div>
                    </motion.div>
                    </form>
                    <motion.div 
                        className="w-full lg:-mt-96 lg:w-2/6 px-8 py-6 ml-auto bg-gray-900 dark:bg-white dark:text-gray-900 rounded-2xl"
                        initial={{ opacity: 0, x: 50, scale: 0.9 }}
                        whileInView={{ opacity: 1, x: 0, scale: 1 }}
                        viewport={{ once: true, margin: "-100px" }}
                        transition={{ duration: 0.8, delay: 0.3 }}
                    >
                        <div className="flex flex-col text-white dark:text-gray-900">     
                            <div className="flex my-4 w-2/3 lg:w-3/4">
                                <div className="flex flex-col">
                                    <i className="fas fa-map-marker-alt pt-2 pr-2" />
                                </div>
                                <div className="flex flex-col">
                                    <h2 className="text-2xl">Adresse du Bureau</h2>
                                    <p className="text-gray-400 dark:text-gray-600">Rue de l'Euro, Immeuble Selim<br />Les Berges Du Lac II, Tunis, Tunisia<br /><br />1288, Rue Saint-Antoine Ouest<br />Montreal, H3C 1C2, Québec, Canada</p>
                                </div>
                            </div>
                            
                            <div className="flex my-4 w-2/3 lg:w-1/2">
                                <div className="flex flex-col">
                                <i className="fas fa-phone-alt pt-2 pr-2" />
                                </div>

                                <div className="flex flex-col">
                                    <h2 className="text-2xl">Appelez-nous</h2>
                                    <p className="text-gray-400 dark:text-gray-600">Tunis: +216 52 814 814<br />Montréal: +1 438 507 9996</p>
                                
                                    <div className='mt-5'>
                                        <h2 className="text-2xl">Envoyez un E-mail</h2>
                                        <p className="text-gray-400 dark:text-gray-600">hello@tomorrow-global.com</p>
                                    </div>
                            
                                </div>
                            </div>
                            
                            <div className="flex my-4 w-2/3 lg:w-1/2">
                                <a href="https://www.facebook.com/ENLIGHTENEERING/" target="_blank" rel="noreferrer" className="rounded-full flex justify-center bg-white h-8 text-gray-900  w-8 mx-1 text-center pt-1">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" className='fill-current font-black hover:animate-pulse'><path d="M13.397 20.997v-8.196h2.765l.411-3.209h-3.176V7.548c0-.926.258-1.56 1.587-1.56h1.684V3.127A22.336 22.336 0 0 0 14.201 3c-2.444 0-4.122 1.492-4.122 4.231v2.355H7.332v3.209h2.753v8.202h3.312z"></path></svg>
                                </a>
                                <a href="https://www.linkedin.com/company/enlighteneering-inc-" target="_blank" rel="noreferrer" className="rounded-full flex justify-center bg-white h-8 text-gray-900  w-8 mx-1 text-center pt-1">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" className='fill-current font-black hover:animate-pulse'><circle cx="4.983" cy="5.009" r="2.188"></circle><path d="M9.237 8.855v12.139h3.769v-6.003c0-1.584.298-3.118 2.262-3.118 1.937 0 1.961 1.811 1.961 3.218v5.904H21v-6.657c0-3.27-.704-5.783-4.526-5.783-1.835 0-3.065 1.007-3.568 1.96h-.051v-1.66H9.237zm-6.142 0H6.87v12.139H3.095z"></path></svg>
                                </a>
                            </div>
                        </div>
                    </motion.div>
                </div>
            </div>
            <Footer />
        </>


    )
}

export default DemoProduct;